import { useEffect, useState, useRef } from 'react';

import ReactPlayer from 'react-player/file';

function Audio({ data }) {
    const player = useRef();
    const [state, setState] = useState({ playing: false });
    const [progress, setProgress] = useState(0);

    function onReady() {
        console.log('Audio.onReady()');
    }

    function onPlay() {
        console.log('Audio.onPlay()');
    }

    function onPause() {
        console.log('Audio.onPause()');
    }

    function onEnded() {
        console.log('Audio.onEnded()');

        setState({ playing: false });
    }

    function onError(event) {
        console.log('Audio.onError()', event);
    }

    function onProgress(event) {
        console.log('Audio.onProgress()', event);

        setProgress(event.played);
    }

    return (
        <div className="Message-audio Audio">
            <ReactPlayer
                url={data?.src}
                ref={player}
                width="auto"
                height="auto"
                playing={state.playing}
                playsinline={true}
                onReady={onReady}
                onPlay={onPlay}
                onPause={onPause}
                onEnded={onEnded}
                onError={onError}
                onProgress={onProgress}
                className="Audio-player"
            ></ReactPlayer>
            <button
                onClick={() => {
                    setState({ playing: !state.playing });
                }}
                className={`Audio-play ${state.playing ? 'pause' : 'play'}`}
            >
                {state.playing ? 'pause' : 'play'}
            </button>

            <Progress progress={progress}></Progress>
        </div>
    );
}

function Progress({ progress }) {
    const [bars, _] = useState(Array.from({ length: 128 }, () => Math.random()));

    return (
        <span className="Audio-progress">
            <span className="Audio-progress-waveform background">
                {bars.map((value) => (
                    <span className="Audio-progress-waveform-bar" style={{ height: `${10 + 90 * value}%` }}></span>
                ))}
            </span>

            <span className="Audio-progress-waveform progress" style={{ width: `${progress * 100}%` }}>
                {bars.map((value) => (
                    <span className="Audio-progress-waveform-bar" style={{ height: `${10 + 90 * value}%` }}></span>
                ))}
            </span>
        </span>
    );
}

export default Audio;
